import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CarregamentoService {
  private readonly carregandoSubject = new BehaviorSubject<boolean>(false);
  private requestCount = 0;
  carregando$ = this.carregandoSubject.asObservable();

  Ativar(): void {
    this.requestCount++;
    if (this.requestCount === 1) {
      this.carregandoSubject.next(true);
    }
  }

  Desativar(): void {
    this.requestCount--;
    if (this.requestCount <= 0) {
      this.requestCount = 0;
      this.carregandoSubject.next(false);
    }
  }

  Reset(): void {
    this.requestCount = 0;
    this.carregandoSubject.next(false);
  }
}
